import { Close } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import SequenceMembersView from "../components/SequenceMembersView";

interface SequenceMembersDialogProps {
  open: boolean;
  onClose: () => void;
  companyId: string;
  sequence?: any;
  getToken: () => Promise<string>;
}

const SequenceMembersDialog: React.FC<SequenceMembersDialogProps> = ({
  open,
  onClose,
  companyId,
  sequence,
  getToken,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">
            Sequence Members: {sequence?.name}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <SequenceMembersView
          companyId={companyId}
          sequence={sequence}
          getToken={getToken}
          showTitle={false}
          showActions={true}
        />
      </DialogContent>
    </Dialog>
  );
};

export default SequenceMembersDialog;